import { graphql } from "../gql";
import { useQuery } from "@apollo/client";
import { useMemo } from "react";

const GetUserIdsWithActivePlansQuery = graphql(`
  query getUserIdsWithActivePlans {
    getUserIdsWithActive1on1Plans
    getUserIdsWithActiveGroupPlans
  }
`);

export type UserActivePlans = {
  hasActiveOneOnOnePlan: boolean;
  hasActiveGroupPlan: boolean;
};

export type ActivePlansOfUser = (userId: string) => UserActivePlans;

export function useUserActivePlans() {
  const { data } = useQuery(GetUserIdsWithActivePlansQuery, {
    fetchPolicy: "cache-and-network",
  });

  const activePlansOf = useMemo<ActivePlansOfUser | undefined>(() => {
    if (!data) return undefined;

    const userIdsWithActiveOneOnOnePlan = new Set(
      data.getUserIdsWithActive1on1Plans,
    );
    const userIdsWithActiveGroupPlan = new Set(
      data.getUserIdsWithActiveGroupPlans,
    );

    return (userId) => ({
      hasActiveOneOnOnePlan: userIdsWithActiveOneOnOnePlan.has(userId),
      hasActiveGroupPlan: userIdsWithActiveGroupPlan.has(userId),
    });
  }, [data]);

  return { activePlansOf };
}
